import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { routes } from '../app.routes';

const CANONICAL = new Map<string, string>();
(function collect(rs: { path?: string; children?: unknown }[]) {
    for (const r of rs) {
        for (const seg of (r.path ?? '').split('/')) {
            if (seg && !seg.startsWith(':') && seg !== '**') CANONICAL.set(seg.toLowerCase(), seg);
        }
        if (Array.isArray(r.children)) collect(r.children as never);
    }
})(routes);

export class CaseInsensitiveUrlSerializer extends DefaultUrlSerializer {
    public override parse(url: string): UrlTree {
        const m = /^([^?#]*)(.*)$/.exec(url)!;
        const path = m[1]
            .split('/')
            .map((seg) => CANONICAL.get(seg.toLowerCase()) ?? seg)
            .join('/');
        return super.parse(path + m[2]);
    }
}
